import { useContext } from 'react';

import {
  AutoOptimizationContext,
  AutoOptimizationContextValue,
} from '../_context/AutoOptimizationContext';

export const useAutoOptimization = (): AutoOptimizationContextValue => {
  const ctx = useContext(AutoOptimizationContext);
  if (!ctx) {
    throw new Error(
      'useAutoOptimization must be used inside AutoOptimizationProvider'
    );
  }
  return ctx;
};
